import { FC, useEffect } from "react";
import { connect } from "react-redux";
import Loader from "app/components/commonComponent/loader/Loader";
import ErrorDisplay from "app/components/commonComponent/ErrorDisplay";
import { getTaskOverview } from "app/reducers/task/taskAction";
import AdminPieChart from "./AdminPieChart";
import { getAuth } from "app/components/pages/auth";
import hasPaymentAccess from "app/components/pages/auth/core/paymentAccess";
import { useNavigate } from "react-router-dom";
import { absolutePath } from "app/helpers/relativePath";
import { TASK_LIST } from "app/helpers/routes";

interface TaskOverviewProps {
  getTaskOverviewDispatch: Function;
  taskOverviewDetail: any;
}

const TaskOverviewPanel: FC<TaskOverviewProps> = ({
  getTaskOverviewDispatch,
  taskOverviewDetail,
}) => {
  const user = getAuth();
  const navigate = useNavigate();

  useEffect(() => {
    getTaskOverviewDispatch();
  }, [getTaskOverviewDispatch]);

  return (
    <>
      {taskOverviewDetail.loading && (
        <div className="p-5">
          <Loader />
        </div>
      )}
      {!taskOverviewDetail.loading && taskOverviewDetail.error && (
        <ErrorDisplay error={taskOverviewDetail.error} />
      )}
      {!taskOverviewDetail.loading &&
        taskOverviewDetail?.taskOverview?.data?.records && (
          <>
            <div className="row">
              {/* AdminPieChart taking 2 rows */}
              {/* <div className=""> */}
                <AdminPieChart taskOverview={taskOverviewDetail?.taskOverview?.data?.records} />
              {/* </div> */}

              {/* Panels beside AdminPieChart */}
              <div className="col-lg-8">
                <div className="row">
                  {/* First row of 4 panels */}
                  <div className="col-12 col-md-6 col-lg-3 mb-4">
                    <div
                      className="card"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`${absolutePath(TASK_LIST)}?PageNumber=1&Filters=DuePriority%3Doverdue`)}
                    >
                      <div className="card-body text-center">
                        <h5 className="card-title">Overdue Tasks</h5>
                        <p className="fs-2 fw-bold text-danger">
                          {
                            taskOverviewDetail.taskOverview.data.records
                              .OverdueTaskCount
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-4">
                    <div
                      className="card"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`${absolutePath(TASK_LIST)}?PageNumber=1&Filters=DuePriority%3Durgent`)}
                    >
                      <div className="card-body text-center">
                        <h5 className="card-title">Urgent Tasks</h5>
                        <p className="fs-2 fw-bold text-info">
                          {
                            taskOverviewDetail.taskOverview.data.records
                              .UrgentTaskCount
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-4">
                    <div
                      className="card"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`${absolutePath(TASK_LIST)}?PageNumber=1&Filters=DuePriority%3Dstartedtoday`)}
                    >
                      <div className="card-body text-center">
                        <h5 className="card-title">Tasks Started Today</h5>
                        <p className="fs-2 fw-bold text-primary">
                          {
                            taskOverviewDetail.taskOverview.data.records
                              .TasksStartedTodayCount
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-4">
                  <div
                      className="card"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`${absolutePath(TASK_LIST)}?PageNumber=1&Filters=DuePriority%3Dduetoday`)}
                    >
                      <div className="card-body text-center">
                        <h5 className="card-title">Tasks Due Today</h5>
                        <p className="fs-2 fw-bold text-warning">
                          {
                            taskOverviewDetail.taskOverview.data.records
                              .TasksDueTodayCount
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Second row with 1 panel */}
                {(hasPaymentAccess() && !user?.Roles?.includes("Admin")) && <div className="row">
                  <div className="col-12 col-md-6 col-lg-3 mb-4">
                    <div className="card">
                      <div className="card-body text-center">
                        <h5 className="card-title">Billing Pending</h5>
                        <p className="fs-2 fw-bold text-success">
                          ₹
                          {taskOverviewDetail.taskOverview.data.records.BillingPendingAmount.toLocaleString("en-IN")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>}
              </div>
            </div>
          </>
        )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    taskOverviewDetail: state.taskOverview,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getTaskOverviewDispatch: () => dispatch(getTaskOverview()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskOverviewPanel);
